import { render, staticRenderFns } from "./batch-list.vue?vue&type=template&id=7e5ff276&"
import script from "./batch-list.vue?vue&type=script&lang=js&"
export * from "./batch-list.vue?vue&type=script&lang=js&"
import style0 from "./batch-list.vue?vue&type=style&index=0&id=7e5ff276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports